import { useStaticQuery, graphql } from 'gatsby';
import useHomepage from '../../hooks/use-homepage';

const useMenuItems = () => {
  const homepage = useHomepage();
  const { strapi } = useStaticQuery(graphql`
    query MenusUsePagesMenuItems {
      strapi {
        menus(
          publicationState: LIVE, # will bubble down to page and subpage
          where: { position: "MainMenu" }
        ) {
          id
          items {
            id
            externalpage {
              id
              externalLink
              externalTitle
            }
            page {
              id
              slug
              title
            }
            homepage
            subpages {
              page {
                subpageId: id
                slug
                title
              }
            }
          }
        }
      }
    }
  `);

  const menuitems = strapi.menus[0]?.items
    .map((item) => {
      // if homepage switch is set, use the homepage as the page
      if (item.homepage) {
        return {
          ...item,
          page: homepage,
        };
      }
      return item;
    })
    .map((item) => {
      // covert subpages to old style subpage
      if (item.subpages.length > 0) {
        return {
          ...item,
          subpages: null,
          subpage: item.subpages.reduce((acc, { page }) => (!page ? acc : acc.concat(page)), []),
        };
      }
      return item;
    })
    // only items with a parent page or externalpage
    .filter(({ page, externalpage }) => page || externalpage);

  return {
    menuitems,
  };
};

export default useMenuItems;
